import { Button, Grid, TextField } from '@mui/material';
import { ActionButtons } from 'components';
import { useFormik } from 'formik';
import { taskStatus } from 'common/constants/taskStatus';
import { useMemo } from 'react';

export const MyTaskForm = ({ onSubmit, onCancel, task }) => {
	const formik = useFormik({
		initialValues: {
			productiveTime: 0,
			subtractTime: 0,
			status: task.status,
		},
		onSubmit,
	});

	const handleAccept = () => {
		formik.setFieldValue('status', taskStatus.ACCEPTED.value);
		formik.handleSubmit();
	};

	const handleStart = () => {
		formik.setFieldValue('status', taskStatus.IN_PROGRESS.value);
		formik.handleSubmit();
	};

	const handleReject = () => {
		formik.setFieldValue('status', taskStatus.REJECTED.value);
		formik.handleSubmit();
	};

	const showButtons = useMemo(() => ({
		accept: formik.values.status === taskStatus.PENDING.value,
		start: [taskStatus.ACCEPTED.value, taskStatus.PENDING.value].includes(formik.values.status),
		reject: formik.values.status === taskStatus.PENDING.value,
	}), [formik.values.status]);

	return (
		<div className="MyTaskForm">
			<form onSubmit={formik.handleSubmit}>
				<Grid container direction="row" spacing={2}>
					<Grid item xs={6}>
						<TextField
							type="number"
							name="productiveTime"
							fullWidth
							id="productiveTime"
							label="Tiempo efectivo"
							value={formik.values.productiveTime}
							onChange={formik.handleChange}
							error={formik.touched.productiveTime && Boolean(formik.errors.productiveTime)}
							helperText={formik.touched.productiveTime && formik.errors.productiveTime}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							type="number"
							name="subtractTime"
							fullWidth
							id="subtractTime"
							label="Restar minutos"
							value={formik.values.subtractTime}
							onChange={formik.handleChange}
							error={formik.touched.subtractTime && Boolean(formik.errors.subtractTime)}
							helperText={formik.touched.subtractTime && formik.errors.subtractTime}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField name="status" fullWidth label="Estatus" value={formik.values.status} onChange={formik.handleChange} />
					</Grid>
				</Grid>
				{/* Retomando proyecto, dedicado 1h de 7.30 am a 8.30 am. Sesión de práctica */}
				<ActionButtons style={{ marginTop: 16 }}>
					{showButtons.accept && (
						<Button variant="contained" title="Aceptar sin iniciar" onClick={handleAccept}>
							Aceptar
						</Button>
					)}
					{showButtons.start && (
						<Button variant="contained" title="Iniciar tarea" color="success" onClick={handleStart}>
							Iniciar
						</Button>
					)}
					{showButtons.reject && (
						<Button variant="outlined" color="error" title="Rechazar tarea" onClick={handleReject}>
							Rechazar
						</Button>
					)}
					<Button onClick={onCancel}>Cerrar</Button>
				</ActionButtons>
			</form>
		</div>
	);
};
